export default __webpack_public_path__ + "static/media/document-pdf.570cbd74.svg";